import React from "react";
import { useTranslation } from "react-i18next";
import {
  Identifiable,
  Milestone,
  milestone as milestoneMock,
  Project,
} from "@planzone/dto";
import { useListsRetrieval, useCreateMilestone } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";

import { Props } from "./types";
import { MilestoneCreationForm } from "./milestoneCreationForm";
import styles from "./styles.scss";

function MilestoneCreation(props: Props) {
  const filter = { limit: 999999999999, start: 0 };
  const [milestone, setMilestone] = React.useState<Milestone>({
    ...milestoneMock,
    keyRank: -1,
    list: props.list,
    ...(props.initialDate && { endDate: props.initialDate }),
  });
  const { t } = useTranslation();
  const { lists, retrieveLists } = useListsRetrieval(props.project, filter);
  const { isRequestPending, error, createMilestone } = useCreateMilestone();
  const [selectedList, setSelectedList] = React.useState(props.list);

  const [selectedProject, setSelectedProject] =
    React.useState<Identifiable<Project> | null>(null);

  const currentProject = selectedProject || props.project;
  React.useEffect(() => {
    props.project.uuid && retrieveLists({ project: currentProject, filter });
  }, [currentProject.uuid]);

  return (
    <Modal header={t("milestoneCreation.title")} close={props.cancel}>
      <form
        onSubmit={(event) => {
          event.preventDefault();
          !isRequestPending &&
            createMilestone({
              list: milestone.list,
              milestone,
              project: currentProject,
            });
        }}
        className={styles.milestoneCreation}
      >
        <div className={styles.main}>
          <MilestoneCreationForm
            error={error}
            formData={milestone}
            lists={
              props.isMultiProject && selectedProject?.rootList
                ? [selectedProject.rootList]
                : [lists]
            }
            editForm={setMilestone}
            isMultiProject={props.isMultiProject}
            onProjectChange={(project) => {
              setSelectedProject(project);
              if (project?.rootList) {
                setSelectedList(project.rootList);
              }
            }}
          />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={props.cancel}>
            {t("milestoneCreation.cancel")}
          </Button>
          <Button
            status={isRequestPending ? "pending" : "none"}
            type="submit"
            isDisabled={props.isMultiProject && !selectedProject}
          >
            {t("milestoneCreation.submit")}
          </Button>
        </div>
      </form>
    </Modal>
  );
}

export { MilestoneCreation };
